import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { PayPalScriptProvider, PayPalButtons , usePayPalScriptReducer} from "@paypal/react-paypal-js";
import axios from "axios";

const Paypalpaymwent = (props) => {
  const { paymentdetails, openTab, tempAmount , complitepayment} = props;

  return (
    <PayPalScriptProvider
    options={{
      "client-id": "AbPfPTA1DySEN7BAws5fLD6sObRs3kNh85TfjBcsqObOqwnk0Vdx-qIrqwFlxazGuYQW1WH98YCse_Zr", // Replace with your PayPal client ID
      currency: "USD",
    }}
  >

          <PayPalButtons
            style={{
              layout: "vertical",
              color: "blue",
              shape: "pill",
              label: "pay",
            }}
            fundingSource="paypal" // Show only the PayPal button
            createOrder={(data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      value: paymentdetails?.amount, // Use the updated amount
                    },
                  },
                ],
                application_context: {
                  shipping_preference: "NO_SHIPPING", // Disable billing address collection
                },
              });
            }}
            onApprove={(data, actions) => {
              return actions.order.capture().then((details) => {
                console.log("Payment Details:", details?.id);
                complitepayment(details?.id, "paypal")
                openTab("", "", "paymentexecution")
            

              });
            }}
            onError={(err) => {
              console.error("PayPal Checkout Error:", err);
            }}
          />
      
  </PayPalScriptProvider>

  );
};

export default Paypalpaymwent;
